import { render, staticRenderFns } from "./Etiquetas.vue?vue&type=template&id=87ec4cae&scoped=true&"
import script from "./Etiquetas.vue?vue&type=script&lang=js&"
export * from "./Etiquetas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ec4cae",
  null
  
)

export default component.exports